module.exports = __webpack_public_path__ + "media/images/social_svgs/tiktok-14fe06c278d19dc677f7fa473db64c61.svg";